
export const ROUTES = {
    HOME: '/',
    DATA_INFO: '/data-info',
    SEARCH: '/search',
    JOBS_DATASET: '/jobs',
    JOBS_DATABASE: '/jobs?toggle=database',
    NEW_DATASET: '/new-dataset',
    NEW_DATABASE: '/new-database',
    NOT_FOUND: '*',
    GENE: '/gene/:gene',
    REGION: '/region/:regionId',
    TRANSCRIPT: '/transcript/:transcriptId',
    VARIANT: '/variant/:variantId',
    AUTH_CALLBACK: '/auth/callback'
}